import React, {useEffect} from 'react';

const AdsenseComponent = ({ adClient, adSlot, adFormat }) => {
    useEffect(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, []);

    useEffect(() => {
        const { googletag } = window
        if (googletag) {
            googletag.cmd.push(function () {
                googletag.pubads().refresh()
            })
        }
    }, [window.location.pathname]);

    return (
        <ins className="adsbygoogle"
             style={{ display: 'block' }}
             data-ad-client={adClient}
             data-ad-slot={adSlot}
             data-ad-format={adFormat}
             data-full-width-responsive="true"></ins>
    );
};

export default AdsenseComponent;